import React, { createContext, useContext, useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 960;

const MobileBreakpointContext = createContext(false);

export const MobileBreakpointProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= MOBILE_BREAKPOINT,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    mq.addEventListener("change", handler);
    setIsMobile(mq.matches);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return (
    <MobileBreakpointContext.Provider value={isMobile}>
      {children}
    </MobileBreakpointContext.Provider>
  );
};

/**
 * Returns true when the viewport is <= 960px.
 * Replaces Ant Design's useBreakpoint() for layout decisions.
 */
export function useIsMobile(): boolean {
  return useContext(MobileBreakpointContext);
}

/**
 * Pins useIsMobile() to a fixed value regardless of viewport — for admin
 * previews that render funnel components inside a phone-width frame.
 */
export const MobileBreakpointOverride: React.FC<{
  value: boolean;
  children: React.ReactNode;
}> = ({ value, children }) => (
  <MobileBreakpointContext.Provider value={value}>
    {children}
  </MobileBreakpointContext.Provider>
);
